import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { InputModuleService } from '../../backend/inputModule';
import { AxiosError } from 'axios';

interface PerformerClientState {
    companiesDetails: {
        status: string,
        data: any,
        error: string | null
    },
    associateCompaniesDetails: {
        status: string,
        data: any,
        error: string | null
    },
    locationsDetails: {
        status: string,
        data: any,
        error: string | null
    },
    statesDetails: {
        status: string,
        data: any,
        error: string | null
    },
    actsDetails: {
        status: string,
        data: any,
        error: string | null
    },
    activitiesDetails: {
        status: string,
        data: any,
        error: string | null
    },
    rulesDetails: {
        status: string,
        data: any,
        error: string | null
    },
    formsDetails: {
        status: string,
        data: any,
        error: string | null
    },
    configUploadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    getColumnsDetails: {
        status: string,
        data: any,
        error: string | null
    },
    downloadFormat: {
        status: string,
        data: any,
        error: string | null
    },
    excelHeaderToDbColumnsDetails: {
        status: string,
        data: any,
        error: string | null
    },
    employeeUploadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    employeeAttendanceUploadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    employeeLeaveCreditUploadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    employeeLeaveAvailedUploadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    employeeWageUploadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    configMappingDetails: {
        status: string,
        data: any,
        error: string | null
    },
    companyEmployerSubContractorsDetails: {
        status: string,
        data: any,
        error: string | null
    },
    employeesDetails: {
        status: string,
        data: any,
        meta: any,
        error: string | null
    },
    employeesAttendanceDetails: {
        status: string,
        data: any,
        meta: any,
        error: string | null
    },
    employeesLeaveCreditDetails: {
        status: string,
        data: any,
        meta: any,
        error: string | null
    },
    employeesLeaveAvailedDetails: {
        status: string,
        data: any,
        meta: any,
        error: string | null
    },
    employeesWageDetails: {
        status: string,
        data: any,
        meta: any,
        error: string | null
    },
    bulkDeleteEmployeeDetails: {
        status: string,
        data: any,
        error: string | null
    },
    bulkDeleteLeaveBalance: {
        status: string,
        data: any,
        error: string | null
    },
    bulkDeleteLeaveAvailed: {
        status: string,
        data: any,
        error: string | null
    },
    bulkDeleteEmployeeAttendance: {
        status: string,
        data: any,
        error: string | null
    },
    bulkDeleteEmployeeWage: {
        status: string,
        data: any,
        error: string | null
    },
    stateRegisterQueDetails: {
        status: string,
        data: any,
        error: string | null
    },
    stateRegisterQueDownloadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    stateRegisterQueExcelandPdfDownloadDetails: {
        status: string,
        data: any,
        error: string | null
    },
    stateConfigureQueDetails: {
        status: string,
        data: any,
        error: string | null
    },
    stateAddStateRegisterQueDetails: {
        status: string,
        data: any,
        error: string | null
    },
    stateUpdateStateRegisterQueDetails: {
        status: string,
        data: any,
        error: string | null
    },
    deleteStateRegisterMappingDetails: {
        status: string,
        data: any,
        error: string | null
    },
    exportFile: {
        status: string,
        data: Blob | null,
        error: string | null
    },
    importStateRegisterMappingDetails: {
        status: string,
        data: any,
        error: string | null
    }
}

const initialState: PerformerClientState = {
    companiesDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    associateCompaniesDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    locationsDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    statesDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    actsDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    activitiesDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    rulesDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    formsDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    configUploadDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    getColumnsDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    downloadFormat: {
        status: 'idle',
        data: {
          file: null
        },
        error: null
    },
    excelHeaderToDbColumnsDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeeUploadDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeeAttendanceUploadDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    employeeLeaveCreditUploadDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    employeeLeaveAvailedUploadDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    employeeWageUploadDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    configMappingDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    companyEmployerSubContractorsDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeesDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeesAttendanceDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeesLeaveCreditDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeesLeaveAvailedDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    employeesWageDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    bulkDeleteEmployeeDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    bulkDeleteLeaveBalance: {
        status: 'idle',
        data: '',
        error: null
    },
    bulkDeleteLeaveAvailed: {
        status: 'idle',
        data: '',
        error: null
    },
    bulkDeleteEmployeeAttendance: {
        status: 'idle',
        data: '',
        error: null
    },
    bulkDeleteEmployeeWage: {
        status: 'idle',
        data: '',
        error: null
    },
    stateRegisterQueDetails: {
        status: 'idle',
        data: {
          items: [],
          meta: {}
        },
        error: null
    },
    stateRegisterQueDownloadDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    stateRegisterQueExcelandPdfDownloadDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    stateConfigureQueDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    stateAddStateRegisterQueDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    stateUpdateStateRegisterQueDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    deleteStateRegisterMappingDetails: {
        status: 'idle',
        data: '',
        error: null
    },
    exportFile: {
        status: 'idle',
        data: null,
        error: null
    },
    importStateRegisterMappingDetails: {
        status: 'idle',
        data: '',
        error: null
    }
} as PerformerClientState

export const getAllCompaniesDetails = createAsyncThunk('performerClient/getAllCompaniesDetails', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.fetchUserCompanies(data);
})

export const getAssociateCompanies = createAsyncThunk('performerClient/getAssociateCompaniesDetails', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.fetchAssociateCompaniesDetails(data);
})

export const getLocations = createAsyncThunk('performerClient/getLocations', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getLocations(data);
})

export const getStates = createAsyncThunk('performerClient/getStates', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getStatesDetails(data);
})

export const getActs = createAsyncThunk('performerClient/getActs', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getActs(data)
})

export const getActivities = createAsyncThunk('performerClient/getActivities', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getActivities(data)
})

export const getRules = createAsyncThunk('performerClient/getRules', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getRules(data)
})

export const getForms = createAsyncThunk('performerClient/getForms', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getForms(data)
})

export const configUpload = createAsyncThunk('performerClient/configUpload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.configUpload(data);
})

export const getColumns = createAsyncThunk('performerClient/getColumns', async (type: string) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getColumns(type);
})

export const getCompanyEmployerSubContractors = createAsyncThunk('performerClient/getCompanyEmployerSubContractors', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getCompanyEmployerSubContractors(data);
})

export const downloadFormat = createAsyncThunk('performerClient/downloadFormat', async (data: any) => {
  let {type, associate_company_id, establishment_type, location_id, employer_id} = data;
    const inputModuleService = new InputModuleService();
    const response = await inputModuleService.downloadFormat(type, associate_company_id, establishment_type, location_id, employer_id);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${type}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
})

export const callExcelHeaderToDbColumns = createAsyncThunk('performerClient/callExcelHeaderToDbColumns', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.callExcelHeaderToDbColumns(data);
})

export const employeeUpload = createAsyncThunk('performerClient/employeeUpload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.employeeUpload(data);
})

export const employeeAttendanceUpload = createAsyncThunk('performerClient/employeeAttendanceUpload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.employeeAttendanceUpload(data);
})

export const employeeLeaveCreditUpload = createAsyncThunk('performerClient/employeeLeaveBalanceUpload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.employeeLeaveBalanceUpload(data);
})

export const employeeLeaveAvailedUpload = createAsyncThunk('performerClient/employeeLeaveAvailedUpload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.employeeLeaveAvailedUpload(data);
})

export const employeeWageUpload = createAsyncThunk('performerClient/employeeWageUpload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.employeeWageUpload(data);
})

export const getInputModuleMappingDetails = createAsyncThunk('performerClient/getInputModuleMappingDetails', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getInputModuleMappingDetails(data);
})

export const getEmployees = createAsyncThunk('performerClient/getEmployees', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getEmployees(data);
})

export const getEmployeesAttendance = createAsyncThunk('performerClient/getEmployeesAttendance', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getEmployeesAttendance(data);
})

export const getEmployeesLeaveCredit = createAsyncThunk('performerClient/getEmployeesLeaveCredit', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getEmployeesLeaveBalance(data);
})

export const getEmployeesLeaveAvailed = createAsyncThunk('performerClient/getEmployeesLeaveAvailed', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getEmployeesLeaveAvailed(data);
})

export const getEmployeesWage = createAsyncThunk('performerClient/getEmployeesWage', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getEmployeesWage(data);
})

export const bulkDeleteEmployees = createAsyncThunk('performerClient/bulkDeleteEmployees', async (id: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.bulkDeleteEmployees(id);
})

export const bulkDeleteLeaveBalance = createAsyncThunk('performerClient/bulkDeleteLeaveBalance', async (id: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.bulkDeleteLeaveBalance(id);
})

export const bulkDeleteLeaveAvailed = createAsyncThunk('performerClient/bulkDeleteLeaveAvailed', async (id: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.bulkDeleteLeaveAvailed(id);
})

export const bulkDeleteEmployeeAttendance = createAsyncThunk('performerClient/bulkDeleteEmployeeAttendance', async (id: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.bulkDeleteEmployeeAttendance(id);
})

export const bulkDeleteEmployeeWage = createAsyncThunk('performerClient/bulkDeleteEmployeeWage', async (id: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.bulkDeleteEmployeeWage(id);
})

export const getStateRegisterQue = createAsyncThunk('performerClient/getstateRegisterQue', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.fetchStateRegisterQue(data);
})

export const getStateRegisterQueDownload = createAsyncThunk('performerClient/getstateRegisterQueDownload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.fetchStateRegisterQueDownload(data);
})

export const getstateRegisterQueExcelandPdfDownloadDetails = createAsyncThunk('performerClient/GetExcelandPdfZipFileDownload', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.fetchStateRegisterQueExcelandPdfDownload(data);
})

export const getStateConfigurationDetails = createAsyncThunk('performerClient/getStateConfigurationDetails', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.getStateConfigurationDetails(data)
})

export const addStateRegisterQue = createAsyncThunk('performerClient/addStateRegisterQue', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.addStateRegisterQue(data.payload, data.establishmentType)
})

export const updateStateRegister = createAsyncThunk('performerClient/updateStateRegister', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.updateStateRegister(data)
})

export const deleteStateRegisterMapping = createAsyncThunk('performerClient/deleteStateRegisterMapping', async (id: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.deleteStateRegisterMapping(id);
})

export const exportStateRegisterMapping = createAsyncThunk('performerClient/exportStateRegisterMapping', async (url: string) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.exportStateRegisterMapping(url);
})

export const importStateRegisterMapping = createAsyncThunk('performerClient/importStateRegisterMapping', async (data: any) => {
    const inputModuleService = new InputModuleService();
    return await inputModuleService.importStateRegisterMapping(data)
})

export const performerClientSlice = createSlice({
    name: 'performerClient',
    initialState,
    reducers: {
        resetConfigUploadDetails: (state) => {
            state.configUploadDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetDownloadFormat: (state) => {
          state.downloadFormat = {
            status: 'idle',
            data: {
              file: null
            },
            error: null
          }
        },
        resetGetColumnsDetails: (state) => {
            state.getColumnsDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetExcelHeaderToDbColumnsDetails: (state) => {
            state.excelHeaderToDbColumnsDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetEmployeeUploadDetails: (state) => {
            state.employeeUploadDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetEmployeeAttendanceUploadDetails: (state) => {
            state.employeeAttendanceUploadDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetEmployeeLeaveCreditUploadDetails: (state) => {
            state.employeeLeaveCreditUploadDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetEmployeeLeaveAvailedUploadDetails: (state) => {
            state.employeeLeaveAvailedUploadDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetEmployeeWageUploadDetails: (state) => {
            state.employeeWageUploadDetails = {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetGetConfigMappingDetails: (state) => {
            state.configMappingDetails= {
                status: 'idle',
                data: '',
                error: null
            }
        },
        resetBulkDeleteEmployees: (state) => {
            state.bulkDeleteEmployeeDetails = {
                status: 'idle',
                data: {
          items: [],
          meta: {}
        },
                error: null
            }
        },
        resetStateConfigQueDetails: (state) => {
          state.stateConfigureQueDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetstateRegisterQueDownloadDetails: (state) => {
          state.stateRegisterQueDownloadDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetstateRegisterQueExcelandPdfDownloadDetails: (state) => {
          state.stateRegisterQueExcelandPdfDownloadDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetstateRegisterQueDetails: (state) => {
          state.stateRegisterQueDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetAddStateRegisterQueDetails: (state) => {
          state.stateAddStateRegisterQueDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetDeleteStateregisterMappingConfigDetails: (state) => {
          state.deleteStateRegisterMappingDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetImportFileDetails: (state) => {
          state.importStateRegisterMappingDetails = {
            status: 'idle',
            data: '',
            error: null
          }
        },
        resetExportFileDetails: (state) => {
          state.exportFile = {
            status: 'idle',
            data: null,
            error: null
          }
        }
    },
    extraReducers: (builder) => builder
        .addCase(getAllCompaniesDetails.pending, (state) => {
            state.companiesDetails.status = 'loading'
        })
        .addCase(getAllCompaniesDetails.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.companiesDetails.status = 'failed'
                state.companiesDetails.error = action.payload.response.data.error;
            } else {
                state.companiesDetails.status = 'succeeded'
                state.companiesDetails.data = action.payload.data
            }
        })
        .addCase(getAllCompaniesDetails.rejected, (state, action: any) => {
            state.companiesDetails.status = 'failed'
            state.companiesDetails.error = action.error.message
        })

        .addCase(getAssociateCompanies.pending, (state) => {
            state.associateCompaniesDetails.status = 'loading'
        })
        .addCase(getAssociateCompanies.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.associateCompaniesDetails.status = 'failed'
                state.associateCompaniesDetails.error = action.payload.response.data.error;
            } else {
                state.associateCompaniesDetails.status = 'succeeded'
                state.associateCompaniesDetails.data = action.payload.data
            }
        })
        .addCase(getAssociateCompanies.rejected, (state, action: any) => {
            state.associateCompaniesDetails.status = 'failed'
            state.associateCompaniesDetails.error = action.error.message
        })

        .addCase(getLocations.pending, (state) => {
            state.locationsDetails.status = 'loading'
        })
        .addCase(getLocations.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.locationsDetails.status = 'succeeded'
                state.locationsDetails.data = action.payload.data
            } else {
                state.locationsDetails.status = 'failed'
                state.locationsDetails.error = action.payload.message;
            }
        })
        .addCase(getLocations.rejected, (state, action: any) => {
            state.locationsDetails.status = 'failed'
            state.locationsDetails.error = action.error.message
        })

        .addCase(getStates.pending, (state) => {
            state.statesDetails.status = 'loading'
        })
        .addCase(getStates.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.statesDetails.status = 'succeeded'
                state.statesDetails.data = action.payload.data
            } else {
                state.statesDetails.status = 'failed'
                state.statesDetails.error = action.payload.message;
            }
        })
        .addCase(getStates.rejected, (state, action: any) => {
            state.statesDetails.status = 'failed'
            state.statesDetails.error = action.error.message
        })

        .addCase(getActs.pending, (state) => {
            state.actsDetails.status = 'loading'
        })
        .addCase(getActs.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.actsDetails.status = 'succeeded'
                state.actsDetails.data = action.payload.data
            } else {
                state.actsDetails.status = 'failed'
                state.actsDetails.error = action.payload.message;
            }
        })
        .addCase(getActs.rejected, (state, action: any) => {
            state.actsDetails.status = 'failed'
            state.actsDetails.error = action.error.message
        })

        .addCase(getActivities.pending, (state) => {
            state.activitiesDetails.status = 'loading'
        })
        .addCase(getActivities.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.activitiesDetails.status = 'succeeded'
                state.activitiesDetails.data = action.payload.data
            } else {
                state.activitiesDetails.status = 'failed'
                state.activitiesDetails.error = action.payload.message;
            }
        })
        .addCase(getActivities.rejected, (state, action: any) => {
            state.activitiesDetails.status = 'failed'
            state.activitiesDetails.error = action.error.message
        })

        .addCase(getRules.pending, (state) => {
            state.rulesDetails.status = 'loading'
        })
        .addCase(getRules.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.rulesDetails.status = 'succeeded'
                state.rulesDetails.data = action.payload.data
            } else {
                state.rulesDetails.status = 'failed'
                state.rulesDetails.error = action.payload.message;
            }
        })
        .addCase(getRules.rejected, (state, action: any) => {
            state.rulesDetails.status = 'failed'
            state.rulesDetails.error = action.error.message
        })

        .addCase(getForms.pending, (state) => {
            state.formsDetails.status = 'loading'
        })
        .addCase(getForms.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.formsDetails.status = 'succeeded'
                state.formsDetails.data = action.payload.data
            } else {
                state.formsDetails.status = 'failed'
                state.formsDetails.error = action.payload.message;
            }
        })
        .addCase(getForms.rejected, (state, action: any) => {
            state.formsDetails.status = 'failed'
            state.formsDetails.error = action.error.message
        })

        .addCase(configUpload.pending, (state) => {
            state.configUploadDetails.status = 'loading'
        })
        .addCase(configUpload.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.configUploadDetails.status = 'failed'
                state.configUploadDetails.error = action.payload;
            } else {
                state.configUploadDetails.status = 'succeeded'
                state.configUploadDetails.data = action.payload
            }
        })
        .addCase(configUpload.rejected, (state, action: any) => {
            state.configUploadDetails.status = 'failed'
            state.configUploadDetails.error = action.error.message
        })

        .addCase(getColumns.pending, (state) => {
            state.getColumnsDetails.status = 'loading'
        })
        .addCase(getColumns.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.getColumnsDetails.status = 'failed'
                state.getColumnsDetails.error = action.payload.response.data.error;
            } else {
                state.getColumnsDetails.status = 'succeeded'
                state.getColumnsDetails.data = action.payload.data
            }
        })
        .addCase(getColumns.rejected, (state, action: any) => {
            state.getColumnsDetails.status = 'failed'
            state.getColumnsDetails.error = action.error.message
        })

        .addCase(downloadFormat.pending, (state) => {
            state.downloadFormat.status = 'loading'
        })
        .addCase(downloadFormat.fulfilled, (state, action: any) => {
            state.downloadFormat.status = 'succeeded'
        })
        .addCase(downloadFormat.rejected, (state, action: any) => {
            state.downloadFormat.status = 'failed'
            state.downloadFormat.error = action.error.message
        })

        .addCase(callExcelHeaderToDbColumns.pending, (state) => {
            state.excelHeaderToDbColumnsDetails.status = 'loading'
        })
        .addCase(callExcelHeaderToDbColumns.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.excelHeaderToDbColumnsDetails.status = 'failed'
                state.excelHeaderToDbColumnsDetails.error = action.payload.response.data.error;
            } else {
                state.excelHeaderToDbColumnsDetails.status = 'succeeded'
                state.excelHeaderToDbColumnsDetails.data = action.payload.data
            }
        })
        .addCase(callExcelHeaderToDbColumns.rejected, (state, action: any) => {
            state.excelHeaderToDbColumnsDetails.status = 'failed'
            state.excelHeaderToDbColumnsDetails.error = action.error.message
        })

        .addCase(employeeUpload.pending, (state) => {
            state.employeeUploadDetails.status = 'loading'
        })
        .addCase(employeeUpload.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.employeeUploadDetails.status = 'failed'
                state.employeeUploadDetails.error = action.payload;
            } else {
                state.employeeUploadDetails.status = 'succeeded'
                state.employeeUploadDetails.data = action.payload
            }
        })
        .addCase(employeeUpload.rejected, (state, action: any) => {
            state.employeeUploadDetails.status = 'failed'
            state.employeeUploadDetails.error = action.error.message
        })

        .addCase(employeeAttendanceUpload.pending, (state) => {
            state.employeeAttendanceUploadDetails.status = 'loading'
        })
        .addCase(employeeAttendanceUpload.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.employeeAttendanceUploadDetails.status = 'failed'
                state.employeeAttendanceUploadDetails.error = action.payload;
            } else {
                state.employeeAttendanceUploadDetails.status = 'succeeded'
                state.employeeAttendanceUploadDetails.data = action.payload
            }
        })
        .addCase(employeeAttendanceUpload.rejected, (state, action: any) => {
            state.employeeAttendanceUploadDetails.status = 'failed'
            state.employeeAttendanceUploadDetails.error = action.error.message
        })

        .addCase(employeeLeaveCreditUpload.pending, (state) => {
            state.employeeLeaveCreditUploadDetails.status = 'loading'
        })
        .addCase(employeeLeaveCreditUpload.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.employeeLeaveCreditUploadDetails.status = 'failed'
                state.employeeLeaveCreditUploadDetails.error = action.payload;
            } else {
                state.employeeLeaveCreditUploadDetails.status = 'succeeded'
                state.employeeLeaveCreditUploadDetails.data = action.payload
            }
        })
        .addCase(employeeLeaveCreditUpload.rejected, (state, action: any) => {
            state.employeeLeaveCreditUploadDetails.status = 'failed'
            state.employeeLeaveCreditUploadDetails.error = action.error.message
        })

        .addCase(employeeLeaveAvailedUpload.pending, (state) => {
            state.employeeLeaveAvailedUploadDetails.status = 'loading'
        })
        .addCase(employeeLeaveAvailedUpload.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.employeeLeaveAvailedUploadDetails.status = 'failed'
                state.employeeLeaveAvailedUploadDetails.error = action.payload;
            } else {
                state.employeeLeaveAvailedUploadDetails.status = 'succeeded'
                state.employeeLeaveAvailedUploadDetails.data = action.payload
            }
        })
        .addCase(employeeLeaveAvailedUpload.rejected, (state, action: any) => {
            state.employeeLeaveAvailedUploadDetails.status = 'failed'
            state.employeeLeaveAvailedUploadDetails.error = action.error.message
        })

        .addCase(employeeWageUpload.pending, (state) => {
            state.employeeWageUploadDetails.status = 'loading'
        })
        .addCase(employeeWageUpload.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.employeeWageUploadDetails.status = 'failed'
                state.employeeWageUploadDetails.error = action.payload;
            } else {
                state.employeeWageUploadDetails.status = 'succeeded'
                state.employeeWageUploadDetails.data = action.payload
            }
        })
        .addCase(employeeWageUpload.rejected, (state, action: any) => {
            state.employeeWageUploadDetails.status = 'failed'
            state.employeeWageUploadDetails.error = action.error.message
        })

        .addCase(getInputModuleMappingDetails.pending, (state) => {
            state.configMappingDetails.status = 'loading'
        })
        .addCase(getInputModuleMappingDetails.fulfilled, (state, action: any) => {
            if(action.payload instanceof AxiosError) {
                state.configMappingDetails.status = 'failed'
                state.configMappingDetails.error = action.payload.response.data.error;
            } else {
                state.configMappingDetails.status = 'succeeded'
                state.configMappingDetails.data = action.payload.data
            }
        })
        .addCase(getInputModuleMappingDetails.rejected, (state, action: any) => {
            state.configMappingDetails.status = 'failed'
            state.configMappingDetails.error = action.error.message
        })

        .addCase(getCompanyEmployerSubContractors.pending, (state) => {
            state.companyEmployerSubContractorsDetails.status = 'loading'
        })
        .addCase(getCompanyEmployerSubContractors.fulfilled, (state, action: any) => {
            if(action.payload) {
                state.companyEmployerSubContractorsDetails.status = 'succeeded'
                state.companyEmployerSubContractorsDetails.data = action.payload.data
            } else {
                state.companyEmployerSubContractorsDetails.status = 'failed'
                state.companyEmployerSubContractorsDetails.error = action.payload.message;
            }
        })
        .addCase(getCompanyEmployerSubContractors.rejected, (state, action: any) => {
            state.companyEmployerSubContractorsDetails.status = 'failed'
            state.companyEmployerSubContractorsDetails.error = action.error.message
        })

        .addCase(getEmployees.pending, (state) => {
            state.employeesDetails.status = 'loading'
        })
        .addCase(getEmployees.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.employeesDetails.status = 'succeeded'
                state.employeesDetails.data = action.payload.data
            } else {
                state.employeesDetails.status = 'failed'
                state.employeesDetails.error = action.payload.message;
            }
        })
        .addCase(getEmployees.rejected, (state, action: any) => {
            state.employeesDetails.status = 'failed'
            state.employeesDetails.error = action.error.message
        })

        .addCase(getEmployeesAttendance.pending, (state) => {
            state.employeesAttendanceDetails.status = 'loading'
        })
        .addCase(getEmployeesAttendance.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.employeesAttendanceDetails.status = 'succeeded'
                state.employeesAttendanceDetails.data = action.payload.data
            } else {
                state.employeesAttendanceDetails.status = 'failed'
                state.employeesAttendanceDetails.error = action.payload.message;
            }
        })
        .addCase(getEmployeesAttendance.rejected, (state, action: any) => {
            state.employeesAttendanceDetails.status = 'failed'
            state.employeesAttendanceDetails.error = action.error.message
        })

        .addCase(getEmployeesLeaveCredit.pending, (state) => {
            state.employeesLeaveCreditDetails.status = 'loading'
        })
        .addCase(getEmployeesLeaveCredit.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.employeesLeaveCreditDetails.status = 'succeeded'
                state.employeesLeaveCreditDetails.data = action.payload.data
            } else {
                state.employeesLeaveCreditDetails.status = 'failed'
                state.employeesLeaveCreditDetails.error = action.payload.message;
            }
        })
        .addCase(getEmployeesLeaveCredit.rejected, (state, action: any) => {
            state.employeesLeaveCreditDetails.status = 'failed'
            state.employeesLeaveCreditDetails.error = action.error.message
        })

        .addCase(getEmployeesLeaveAvailed.pending, (state) => {
            state.employeesLeaveAvailedDetails.status = 'loading'
        })
        .addCase(getEmployeesLeaveAvailed.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.employeesLeaveAvailedDetails.status = 'succeeded'
                state.employeesLeaveAvailedDetails.data = action.payload.data
            } else {
                state.employeesLeaveAvailedDetails.status = 'failed'
                state.employeesLeaveAvailedDetails.error = action.payload.message;
            }
        })
        .addCase(getEmployeesLeaveAvailed.rejected, (state, action: any) => {
            state.employeesLeaveAvailedDetails.status = 'failed'
            state.employeesLeaveAvailedDetails.error = action.error.message
        })

        .addCase(getEmployeesWage.pending, (state) => {
            state.employeesWageDetails.status = 'loading'
        })
        .addCase(getEmployeesWage.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.employeesWageDetails.status = 'succeeded'
                state.employeesWageDetails.data = action.payload.data
            } else {
                state.employeesWageDetails.status = 'failed'
                state.employeesWageDetails.error = action.payload.message;
            }
        })
        .addCase(getEmployeesWage.rejected, (state, action: any) => {
            state.employeesWageDetails.status = 'failed'
            state.employeesWageDetails.error = action.error.message
        })

        .addCase(bulkDeleteEmployees.pending, (state) => {
            state.bulkDeleteEmployeeDetails.status = 'loading'
        })
        .addCase(bulkDeleteEmployees.fulfilled, (state, action: any) => {
            if (action.payload) {
                state.bulkDeleteEmployeeDetails.status = 'succeeded'
                state.bulkDeleteEmployeeDetails.data = action.payload.data
            } else {
                state.bulkDeleteEmployeeDetails.status = 'failed'
                state.bulkDeleteEmployeeDetails.error = action.payload.message;
            }
        })
        .addCase(bulkDeleteEmployees.rejected, (state, action: any) => {
            state.bulkDeleteEmployeeDetails.status = 'failed'
            state.bulkDeleteEmployeeDetails.error = action.error.message
        })

        .addCase(bulkDeleteLeaveBalance.pending, (state) => {
            state.bulkDeleteLeaveBalance.status = 'loading'
        })
        .addCase(bulkDeleteLeaveBalance.fulfilled, (state, action: any) => {
            if (action.payload) {
                state.bulkDeleteLeaveBalance.status = 'succeeded'
                state.bulkDeleteLeaveBalance.data = action.payload.data
            } else {
                state.bulkDeleteLeaveBalance.status = 'failed'
                state.bulkDeleteLeaveBalance.error = action.payload.message;
            }
        })
        .addCase(bulkDeleteLeaveBalance.rejected, (state, action: any) => {
            state.bulkDeleteLeaveBalance.status = 'failed'
            state.bulkDeleteLeaveBalance.error = action.error.message
        })

        .addCase(bulkDeleteLeaveAvailed.pending, (state) => {
            state.bulkDeleteLeaveAvailed.status = 'loading'
        })
        .addCase(bulkDeleteLeaveAvailed.fulfilled, (state, action: any) => {
            if (action.payload) {
                state.bulkDeleteLeaveAvailed.status = 'succeeded'
                state.bulkDeleteLeaveAvailed.data = action.payload.data
            } else {
                state.bulkDeleteLeaveAvailed.status = 'failed'
                state.bulkDeleteLeaveAvailed.error = action.payload.message;
            }
        })
        .addCase(bulkDeleteLeaveAvailed.rejected, (state, action: any) => {
            state.bulkDeleteLeaveAvailed.status = 'failed'
            state.bulkDeleteLeaveAvailed.error = action.error.message
        })

        .addCase(bulkDeleteEmployeeAttendance.pending, (state) => {
            state.bulkDeleteEmployeeAttendance.status = 'loading'
        })
        .addCase(bulkDeleteEmployeeAttendance.fulfilled, (state, action: any) => {
            if (action.payload) {
                state.bulkDeleteEmployeeAttendance.status = 'succeeded'
                state.bulkDeleteEmployeeAttendance.data = action.payload.data
            } else {
                state.bulkDeleteEmployeeAttendance.status = 'failed'
                state.bulkDeleteEmployeeAttendance.error = action.payload.message;
            }
        })
        .addCase(bulkDeleteEmployeeAttendance.rejected, (state, action: any) => {
            state.bulkDeleteEmployeeAttendance.status = 'failed'
            state.bulkDeleteEmployeeAttendance.error = action.error.message
        })

        .addCase(bulkDeleteEmployeeWage.pending, (state) => {
            state.bulkDeleteEmployeeWage.status = 'loading'
        })
        .addCase(bulkDeleteEmployeeWage.fulfilled, (state, action: any) => {
            if (action.payload) {
                state.bulkDeleteEmployeeWage.status = 'succeeded'
                state.bulkDeleteEmployeeWage.data = action.payload.data
            } else {
                state.bulkDeleteEmployeeWage.status = 'failed'
                state.bulkDeleteEmployeeWage.error = action.payload.message;
            }
        })
        .addCase(bulkDeleteEmployeeWage.rejected, (state, action: any) => {
            state.bulkDeleteEmployeeWage.status = 'failed'
            state.bulkDeleteEmployeeWage.error = action.error.message
        })

        .addCase(getStateRegisterQue.pending, (state) => {
            state.stateRegisterQueDetails.status = 'loading'
        })
        .addCase(getStateRegisterQue.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.stateRegisterQueDetails.status = 'succeeded'
                state.stateRegisterQueDetails.data = action.payload.data
            } else {
                state.stateRegisterQueDetails.status = 'failed'
                state.stateRegisterQueDetails.error = action.payload.message;
            }
        })
        .addCase(getStateRegisterQue.rejected, (state, action: any) => {
            state.stateRegisterQueDetails.status = 'failed'
            state.stateRegisterQueDetails.error = action.error.message
        })

        .addCase(getStateRegisterQueDownload.pending, (state) => {
            state.stateRegisterQueDownloadDetails.status = 'loading'
        })
        .addCase(getStateRegisterQueDownload.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.stateRegisterQueDownloadDetails.status = 'succeeded'
                state.stateRegisterQueDownloadDetails.data = action.payload.data
            } else {
                state.stateRegisterQueDownloadDetails.status = 'failed'
                state.stateRegisterQueDownloadDetails.error = action.payload.message;
            }
        })
        .addCase(getStateRegisterQueDownload.rejected, (state, action: any) => {
            state.stateRegisterQueDownloadDetails.status = 'failed'
            state.stateRegisterQueDownloadDetails.error = action.error.message
        })

        .addCase(getstateRegisterQueExcelandPdfDownloadDetails.pending, (state) => {
            state.stateRegisterQueExcelandPdfDownloadDetails.status = 'loading'
        })
        .addCase(getstateRegisterQueExcelandPdfDownloadDetails.fulfilled, (state, action: any) => {
            if(action.payload.data) {
                state.stateRegisterQueExcelandPdfDownloadDetails.status = 'succeeded'
                state.stateRegisterQueExcelandPdfDownloadDetails.data = action.payload.data
            } else {
                state.stateRegisterQueExcelandPdfDownloadDetails.status = 'failed'
                state.stateRegisterQueExcelandPdfDownloadDetails.error = action.payload.message;
            }
        })
        .addCase(getstateRegisterQueExcelandPdfDownloadDetails.rejected, (state, action: any) => {
            state.stateRegisterQueExcelandPdfDownloadDetails.status = 'failed'
            state.stateRegisterQueExcelandPdfDownloadDetails.error = action.error.message
        })

        .addCase(addStateRegisterQue.pending, (state) => {
          state.stateAddStateRegisterQueDetails.status = 'loading'
        })
        .addCase(addStateRegisterQue.fulfilled, (state, action: any) => {
          if(action.payload.data) {
            state.stateAddStateRegisterQueDetails.status = 'succeeded'
            state.stateAddStateRegisterQueDetails.data = action.payload.data
          } else {
            state.stateAddStateRegisterQueDetails.status = 'failed'
            state.stateAddStateRegisterQueDetails.error = action.payload.message;
          }
        })
        .addCase(addStateRegisterQue.rejected, (state, action: any) => {
          state.stateAddStateRegisterQueDetails.status = 'failed'
          state.stateAddStateRegisterQueDetails.error = action.error.message
        })
})

export const {
  resetGetConfigMappingDetails, resetConfigUploadDetails, resetGetColumnsDetails,
  resetExcelHeaderToDbColumnsDetails, resetEmployeeUploadDetails,
  resetEmployeeAttendanceUploadDetails, resetEmployeeLeaveCreditUploadDetails,
  resetEmployeeLeaveAvailedUploadDetails, resetEmployeeWageUploadDetails,
  resetDownloadFormat, resetBulkDeleteEmployees,
  resetstateRegisterQueDetails, resetstateRegisterQueExcelandPdfDownloadDetails,
  resetStateConfigQueDetails, resetstateRegisterQueDownloadDetails,
  resetImportFileDetails, resetExportFileDetails, resetAddStateRegisterQueDetails,
  resetDeleteStateregisterMappingConfigDetails
} = performerClientSlice.actions

export default performerClientSlice.reducer
